import React from 'react';

const SurveyEmailTemplate = ({ surveyName, surveyLink, contactName }) => {
  const currentYear = new Date().getFullYear();

  const subject = `Share Your Feedback – CriticalRiver CSAT ${surveyName} Survey`;

  const htmlContent = `
    <html>
<head>
  <meta charset="UTF-8">
  <title>${subject}</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      background-color: #f4f6f8;
      margin: 0;
      padding: 0;
    }
    .survey-button-container {
      text-align: center;
    }
    .email-container {
      max-width: 600px;
      margin: 40px auto;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    }
    .email-header {
      background-color: #004aad;
      color: #ffffff;
      padding: 1px;
      text-align: center;
    }
    .email-body {
      padding: 30px 20px;
      color: #333333;
    }
    .email-footer {
      font-size: 12px;
      color: #999999;
      text-align: center;
      padding: 20px;
    }
    .survey-button {
      display: inline-block;
      margin-top: 20px;
      padding: 12px 24px;
      background-color: #004aad;
      color: white;
      text-decoration: none;
      border-radius: 5px;
      font-weight: bold;
    }
    @media (max-width: 600px) {
      .email-body {
        padding: 20px 10px;
      }
    }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="email-header">
      <h2>Share Your Feedback</h2>
    </div>
    <div class="email-body">
      <p>We value your partnership and would love your feedback.</p>

      <p>Your opinion is important to us. Please take a few minutes to share your experience with our 
      <b>CriticalRiver CSAT – ${surveyName} Survey</b>.</p>

      <p>Your input will help us better understand your needs, enhance our collaboration, and deliver greater value in the future.</p>

      <div class="survey-button-container">
        <a href="${surveyLink}" class="survey-button" target="_blank">Take the Survey</a>
      </div>

      <p style="margin-top: 30px;">Thank you for your time and continued trust in CriticalRiver.</p>

      <p><b>CriticalRiver Technologies Team</b><br/>${surveyName} Survey</p>
    </div>
    <div class="email-footer">
      © ${currentYear} CriticalRiver Technologies. All rights reserved.
    </div>
  </div>
</body>
</html>
  `;

  // Simplified display content for UI (name and URL only)
  const displayContent = `Name: ${contactName}\nURL: ${surveyLink}`;

  return { subject, html: htmlContent, display: displayContent };
};

export default SurveyEmailTemplate;